export enum MissingInfoPage {
  NoticeOfPrivacyPractice = "notice_of_privacy_practice",
  RequiredConsentNotices = "required_consent_notices",
  OptionalConsentNotices = "optional_consent_notices",
  PersonalInformation = "personal_information",
  AccountInformation = "account_information",
  Password = "password",
}
